import React from "react"
import PropTypes from "prop-types"

import styles from "./navitem.module.css"

export const NavItem = ({ children, ...props }) => {
  // filtering out style and className
  /* eslint-disable-next-line react/prop-types */
  const { style, className, ...rest } = props

  return (
    <li {...rest} role="none" className={styles.NavItem}>
      {children}
    </li>
  )
}

NavItem.displayName = "NavItem"

NavItem.propTypes = {
  /**
   * Content for a nav item.
   */
  children: PropTypes.node.isRequired,
}
